export const recoveryRoom = {
	patient_correctly_identified: "",
	post_operative_admission_record: "",
	pacu_pain_monitoring: "",
	aldrete_scale: "",
	discharge_condition_record: "",
	arrival_condition_record: "",
	inpatient_unit_pain_monitoring: "",
	arrival_binomial: "" as string | undefined,
	responsible_professional_id: "",
};
